import React, {useState, useEffect} from 'react';
import Layout from '../layout';
import {css} from 'emotion';
import Input from '../common/material-easy-ui/input/Input';
import InputPassword from '../common/material-easy-ui/input/InputPassword';
import Button from '../common/material-easy-ui/button/Button';
import ModalError from '../common/modalError';
import ModalValidation from '../common/modal-valid';
import {useSelector, useDispatch} from 'react-redux';
import {
  updatePersonalData,
  updateAvatarUser,
  updateBoatUser,
  updateAdressUser,
} from '../../redux/actions/userActions';
import ModalSuccess from './components/ModalSuccess';

import AvatarPicker from './avatarPicker';
import UserAPI from '../../api/UserAPI';

const ProfilePage = props => {
  const dispatch = useDispatch();
  const info_user = useSelector(state => state.user.info_user);
  const popkey = useSelector(state => state.user.popkey);
  const error_profile = useSelector(state => state.user.error_profile);
  const valid_profile = useSelector(state => state.user.valid_profile);

  const [firstName, setFirstName] = useState(info_user.firstname);
  const [lastName, setLastName] = useState(info_user.name);
  const [pseudo, setPseudo] = useState(info_user.pseudo);
  const [avatar, setAvatar] = useState(info_user.avatar);
  const [password, setPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [immatriculation_boat, setImmatriculation_boat] = useState(
    info_user.boat_immatriculation,
  );
  const [name_boat, setName_boat] = useState(info_user.boat_name);
  const [id_boat, setId_boat] = useState(info_user.id_boat);
  const [adress, setAdress] = useState(info_user.adress_postal);

  const [error_firstName, set_Error_firstName] = useState(false);
  const [error_lastName, set_Error_lastName] = useState(false);
  const [error_pseudo, set_Error_pseudo] = useState(false);
  const [error_password, set_Error_password] = useState(false);
  const [error_newPassword, set_Error_newPassword] = useState(false);
  const [error_immatriculation_boat, set_Error_immatriculation_boat] = useState(
    false,
  );
  const [error_name_boat, set_Error_name_boat] = useState(false);
  const [persoData, setPersoData] = useState(false);
  const [boatData, setBoatData] = useState(false);
  const [adressData, setAdressData] = useState(false);
  const [error_adress, setError_adress] = useState(false);

  const [success_message, setSucccess_message] = useState(false);

  const onChangeFirstName = e => {
    setFirstName(
      e.target.value.charAt(0).toUpperCase() +
        e.target.value.slice(1).toLowerCase(),
    );
    if (!persoData) setPersoData(true);
  };

  const onChangeLastName = e => {
    setLastName(
      e.target.value.charAt(0).toUpperCase() +
        e.target.value.slice(1).toLowerCase(),
    );
    if (!persoData) setPersoData(true);
  };

  const onChangePseudo = e => {
    setPseudo(e.target.value);
    if (!persoData) setPersoData(true);
  };

  const removeDataPerso = e => {
    if (persoData) {
      setFirstName(info_user.firstname);
      setLastName(info_user.name);
      setPseudo(info_user.pseudo);
      setPersoData(false);
    }
  };

  const onChooseAvatar = avatar => {
    setAvatar(avatar);
  };

  const onChangePassword = e => {
    setPassword(e.target.value);
  };

  const onChangenewPassword = e => {
    setNewPassword(e.target.value);
  };

  const onChangeAdress = e => {
    setAdress(e.target.value);
    if (!adressData) setAdressData(true);
  };

  const onChangeImmatBoat = e => {
    setImmatriculation_boat(e.target.value);
    if (!persoData) setBoatData(true);
  };

  const onChangeNameBoat = e => {
    setName_boat(e.target.value);
    if (!persoData) setBoatData(true);
  };

  const removeBoatData = e => {
    if (boatData) {
      setImmatriculation_boat(info_user.boat_immatriculation);
      setName_boat(info_user.boat_name);
      setBoatData(false);
    }
  };

  const removeAdressData = e => {
    if (adressData) {
      setAdress(info_user.adress);
      setAdressData(false);
    }
  };

  const updatePersoData = e => {
    dispatch(updatePersonalData(firstName, lastName, pseudo, popkey));
  };

  const updateAvatar = e => {
    dispatch(updateAvatarUser(popkey, avatar));
  };

  const updateBoat = e => {
    dispatch(updateBoatUser(popkey, immatriculation_boat, name_boat, id_boat));
  };

  const updateAdress = e => {
    dispatch(updateAdressUser(popkey, adress));
  };

  const updatePassword = e => {
    dispatch({type: 'UPDATE_PASSWORD_LOADING'});
    UserAPI.updatePassworduser(popkey, password, newPassword)
      .then(data => {
        dispatch({type: 'UPDATE_PASSWORD_SUCCESS'});
        setSucccess_message('Vous avez changé votre mot de passe');
      })
      .catch(error => {
        dispatch({
          type: 'UPDATE_PASSWORD_ERROR',
          payload: {error: error.response.data.error.details},
        });
      });
  };

  const onCloseError = () => {
    dispatch({type: 'CLEAR_ERROR_PROFILE'});
  };
  const onCloseSuccess = () => {
    setSucccess_message(false);
  };
  const onCloseValidation = () => {
    dispatch({type: 'CLEAR_VALID_PROFILE'});
  };

  return (
    <Layout location={props.location}>
      <div
        className={css`
          max-width: 678px;
          margin: 0 auto;
        `}>
        <div
          className={css`
            background-color: white;
            box-sizing: border-box;
            padding: 20px;
          `}>
          <div
            className={css`
              color: #3f4d6e;
              font-weight: 600;
            `}>
            DONNEES PERSONNELLES
          </div>
          <Input
            error={error_firstName}
            style={{
              height: 40,
              marginTop: 20,
              paddingLeft: 20,
              paddingRight: 20,
              display: 'flex',
              alignItems: 'center',
              paddingTop: 5,
              paddingBottom: 5,
            }}
            inputStyle={{fontSize: 15}}
            labelStyle={{color: '#cccccc'}}
            onChangeText={onChangeFirstName}
            placeholder={'Prénom'}
            text={firstName}
          />
          <Input
            error={error_lastName}
            style={{
              height: 40,
              marginTop: 20,
              paddingLeft: 20,
              paddingRight: 20,
              display: 'flex',
              alignItems: 'center',
              paddingTop: 5,
              paddingBottom: 5,
            }}
            inputStyle={{fontSize: 15}}
            labelStyle={{color: '#cccccc'}}
            onChangeText={onChangeLastName}
            placeholder={'Nom'}
            text={lastName}
          />
          <Input
            error={error_pseudo}
            style={{
              height: 40,
              marginTop: 20,
              paddingLeft: 20,
              paddingRight: 20,
              display: 'flex',
              alignItems: 'center',
              paddingTop: 5,
              paddingBottom: 5,
            }}
            inputStyle={{fontSize: 15}}
            labelStyle={{color: '#cccccc'}}
            onChangeText={onChangePseudo}
            placeholder={'Pseudo'}
            text={pseudo}
          />
          <div
            className={css`
              display: flex;
              flex-direction: row;
              justify-content: flex-end;
            `}>
            <Button
              onPress={updatePersoData}
              color={'#0085C6'}
              text={'Mise à jour'}
              hoverColor={'#5c9ebf'}
            />
            <Button
              style={{marginLeft: '10px'}}
              onPress={removeDataPerso}
              color={persoData ? '#ffb300' : '#a3a3a3'}
              text={'Annuler'}
              hoverColor={persoData ? '#ffda82' : '#d9d9d9'}
            />
          </div>
        </div>
        <div
          className={css`
            background-color: white;
            box-sizing: border-box;
            padding: 20px;
            margin-top: 10px;
          `}>
          <div
            className={css`
              color: #3f4d6e;
              font-weight: 600;
            `}>
            AVATAR
          </div>
          <AvatarPicker avatarChoose={avatar} onChooseAvatar={onChooseAvatar} />
          <div
            className={css`
              display: flex;
              flex-direction: row;
              justify-content: flex-end;
            `}>
            <Button
              onPress={updateAvatar}
              color={'#0085C6'}
              text={'Mise à jour'}
              hoverColor={'#5c9ebf'}
            />
          </div>
        </div>
        <div
          className={css`
            background-color: white;
            box-sizing: border-box;
            padding: 20px;
            margin-top: 10px;
          `}>
          <div
            className={css`
              color: #3f4d6e;
              font-weight: 600;
            `}>
            Adresse Postale
          </div>
          <Input
            error={error_adress}
            style={{
              height: 40,
              marginTop: 20,
              paddingLeft: 20,
              paddingRight: 20,
              display: 'flex',
              alignItems: 'center',
              paddingTop: 5,
              paddingBottom: 5,
            }}
            inputStyle={{fontSize: 15}}
            labelStyle={{color: '#cccccc'}}
            onChangeText={onChangeAdress}
            placeholder={'Adresse Postale'}
            text={adress == null ? '' : adress}
          />
          <div
            className={css`
              display: flex;
              flex-direction: row;
              justify-content: flex-end;
            `}>
            <Button
              onPress={updateAdress}
              color={'#0085C6'}
              text={'Mise à jour'}
              hoverColor={'#5c9ebf'}
            />
            <Button
              style={{marginLeft: '10px'}}
              onPress={removeAdressData}
              color={adressData ? '#ffb300' : '#a3a3a3'}
              text={'Annuler'}
              hoverColor={adressData ? '#ffda82' : '#d9d9d9'}
            />
          </div>
        </div>

        <div
          className={css`
            background-color: white;
            box-sizing: border-box;
            padding: 20px;
            margin-top: 10px;
          `}>
          <div
            className={css`
              color: #3f4d6e;
              font-weight: 600;
            `}>
            NAVIRE
          </div>
          <Input
            error={error_immatriculation_boat}
            style={{
              height: 40,
              marginTop: 20,
              paddingLeft: 20,
              paddingRight: 20,
              display: 'flex',
              alignItems: 'center',
              paddingTop: 5,
              paddingBottom: 5,
            }}
            inputStyle={{fontSize: 15}}
            labelStyle={{color: '#cccccc'}}
            onChangeText={onChangeImmatBoat}
            placeholder={'Immatrication du bateau'}
            text={immatriculation_boat == null ? '' : immatriculation_boat}
          />
          <Input
            error={error_name_boat}
            style={{
              height: 40,
              marginTop: 20,
              paddingLeft: 20,
              paddingRight: 20,
              display: 'flex',
              alignItems: 'center',
              paddingTop: 5,
              paddingBottom: 5,
            }}
            inputStyle={{fontSize: 15}}
            labelStyle={{color: '#cccccc'}}
            onChangeText={onChangeNameBoat}
            placeholder={'Nom du bateau'}
            text={name_boat == null ? '' : name_boat}
          />

          <div
            className={css`
              display: flex;
              flex-direction: row;
              justify-content: flex-end;
            `}>
            <Button
              onPress={updateBoat}
              color={'#0085C6'}
              text={'Mise à jour'}
              hoverColor={'#5c9ebf'}
            />
            <Button
              style={{marginLeft: '10px'}}
              onPress={removeBoatData}
              color={boatData ? '#ffb300' : '#a3a3a3'}
              text={'Annuler'}
              hoverColor={boatData ? '#ffda82' : '#d9d9d9'}
            />
          </div>
        </div>
        <div
          className={css`
            background-color: white;
            box-sizing: border-box;
            padding: 20px;
            margin-top: 10px;
          `}>
          <div
            className={css`
              color: #3f4d6e;
              font-weight: 600;
            `}>
            MOT DE PASSE
          </div>

          <InputPassword
            error={error_password}
            style={{
              height: 40,
              marginTop: 20,
              paddingLeft: 20,
              paddingRight: 20,
              display: 'flex',
              alignItems: 'center',
              paddingTop: 5,
              paddingBottom: 5,
            }}
            inputStyle={{fontSize: 15}}
            labelStyle={{color: '#cccccc'}}
            onChange={onChangePassword}
            placeholder={'Nouveau mot de passe'}
            text={password}
          />

          <InputPassword
            error={error_newPassword}
            style={{
              height: 40,
              marginTop: 20,
              paddingLeft: 20,
              paddingRight: 20,
              display: 'flex',
              alignItems: 'center',
              paddingTop: 5,
              paddingBottom: 5,
            }}
            inputStyle={{fontSize: 15}}
            labelStyle={{color: '#cccccc'}}
            onChange={onChangenewPassword}
            placeholder={'Nouveau mot de passe de confirmation'}
            text={newPassword}
          />

          <div
            className={css`
              display: flex;
              flex-direction: row;
              justify-content: flex-end;
            `}>
            <Button
              onPress={updatePassword}
              color={'#0085C6'}
              text={'Mise à jour'}
              hoverColor={'#5c9ebf'}
            />
          </div>
        </div>
      </div>
      {error_profile && (
        <ModalError onClose={onCloseError} message={error_profile} />
      )}
      {valid_profile && (
        <ModalValidation
          onClose={onCloseValidation}
          message={'Votre compte est à jour'}
        />
      )}
      {success_message && (
        <ModalSuccess onClose={onCloseSuccess} message={success_message} />
      )}
    </Layout>
  );
};

export default ProfilePage;
